import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    wikiContentRoot: {
      width: '100%',
      '& h1': {
        fontSize: '1.3rem',
        fontWeight: 500,
        marginLeft: 0,
        marginTop: '20px'
      },
      '& h2': {
        fontSize: '1.1rem',
        fontWeight: 500,
        marginTop: '20px'
      },
      '& h3': {
        fontSize: '1.0rem',
        fontWeight: 400
      },
      '& h4': {
        fontSize: '1.0rem',
        fontWeight: 400
      }
    },
    tableRoot: {
      margin: '14px 0px 14px 0px',
      '& thead > tr > th': {
        border: '1px solid #cccccc',
        padding: '6px',
        color: '#666666',
        fontSize: '0.9rem',
        fontWeight: '600',
        textAlign: 'left'
      },
      '& tbody > tr > td': {
        border: '1px solid #cccccc',
        padding: '6px',
        textAlign: 'left',
        wordBreak: 'break-word'
      }
    },
    imageRoot: {
      width: '100%'
    },
    embededVideoRoot: {
      display: 'block',
      margin: '40px auto'
    }
  });
